import { render, staticRenderFns } from "./modalRouteRegion.vue?vue&type=template&id=85b16ace&scoped=true"
import script from "./modalRouteRegion.vue?vue&type=script&lang=js"
export * from "./modalRouteRegion.vue?vue&type=script&lang=js"
import style0 from "./modalRouteRegion.vue?vue&type=style&index=0&id=85b16ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b16ace",
  null
  
)

export default component.exports